import { render, staticRenderFns } from "./ConsensiViewPage.vue?vue&type=template&id=92f60c5a"
import script from "./ConsensiViewPage.vue?vue&type=script&lang=js"
export * from "./ConsensiViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports